import {Fragment} from 'react'
import PropTypes from 'prop-types'

import {Button} from '../../../../../dashboard/src/components/blocks/Buttons'
import ButtonGroup from '../../../../../shared_components/mui_base_components/button/ButtonGroup'
import {TextGutterMedium} from '../../../../../dashboard/src/components/blocks/Texts'
import UnorderedList from '../../../../../shared_components/UnorderedList'

import finishTfaSetup from '../../../../../shared_assets/finishTFASetup.png'

const SuccessMessage = props => {
  const instructions = () => {
    let messages = ["You'll be asked for a verification code each time you sign in"]

    if (props.mode === 'app') {
      messages = [
        ...messages,
        'Use backup codes if you lose access to your authenticator',
        'If you get a new phone, use the built-in export or sync feature in your authenticator app to transfer data'
      ]
    } else {
      messages = [...messages, 'You will receive the verification code via phone']
    }

    return messages
  }

  return (
    <Fragment>
      <h2 className='success-heading'>You're all set!</h2>
      <TextGutterMedium>Two-factor authentication is now enabled on your account.</TextGutterMedium>
      <img
        className='success-image'
        src={finishTfaSetup}
        alt='Illustration of a person with a green checkmark shield on their phone screen, indicating successful setup of two-factor authentication'
      />
      <h3 className='up-next'>What happens next?</h3>
      <UnorderedList className='success-instructions' children={instructions()} />
      <ButtonGroup>
        <Button onClick={props.onFinish}>Done</Button>
      </ButtonGroup>
    </Fragment>
  )
}

SuccessMessage.propTypes = {
  mode: PropTypes.string.isRequired,
  onFinish: PropTypes.func.isRequired
}

export default SuccessMessage
